export default {
  name: 'Acollapse',
  props: {
    accordion: { type: Boolean, default: () => true },
    title: { type: String, default: () => '' },
    icon: { type: String, default: () => '' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    content: { type: String, default: () => [] },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div>
        <el-collapse accordion {...{ attrs }}>
          {data.length > 0 ? data.map((a, b) => (
            <el-collapse-item key={b}>
              <template slot="title">{a.label}<i class={a.icon}></i></template>
              <div>{a.value}</div>
            </el-collapse-item>
          )) : (
              <el-collapse-item>
                <template slot="title">{this.title}<i class={this.icon}></i></template>
                <div>{this.content}</div>
              </el-collapse-item>
            )
          }
        </el-collapse>
      </div>
    );
  }
}